export interface GiftCardDenomination {
  id: string;
  displayType: GiftCardType;
  displayValue: number;
  maxQuantity?: number;
  price: number;
  pricingParameters?: PricingParameters;
  validityInDays: number;
  minValidityInDays: number | null;
}

export interface PricingParameters {
  cash: {
    min: number;
    max: number;
    value: number; // total cash value from Alfred
  };
  points: {
    min: number;
    max: number;
    value: number; // total points value from NN
  };
}

// Config source : https://developer.blackhawknetwork.com/digital-gift-services/docs/createorder#section-address
export enum PhysicalGiftCardFieldsMaxLength {
  FIRST_NAME = 30,
  LAST_NAME = 30,
  COMPANY_NAME = 35,
  PHONE_NUMBER = 30,
  ADDRESS_LINE_1 = 35,
  ADDRESS_LINE_2 = 35,
  CITY = 35,
  POSTAL_CODE = 4,
}

export enum GiftCardDeliveryMethod {
  EmailAndSms = 'email_and_sms',
  EmailOrSms = 'email_or_sms',
  EmailOnly = 'email',
  SmsOnly = 'sms',
  Mms = 'mms',
}

export enum GiftCardRedemptionChannel {
  RedeemOnline = 'redeem_online',
  RedeemAtStore = 'redeem_at_store',
  SelfRedemption = 'self_redemption',
  DirectRedemption = 'direct_redemption',
  RedeemOnlineAndInstore = 'redeem_online_and_instore',
}

export enum GiftCardCategory {
  All = 'all',
  BeautyAndHealth = 'beauty',
  Dining = 'dining',
  Others = 'others',
  Retail = 'retail',
}

export enum GiftCardSort {
  None = '',
  Alphabet = 'name',
  ReverseAlphabet = '-name',
}

export enum GiftCardType {
  All = 'all',
  Physical = 'physical',
  Digital = 'digital',
}
export interface GiftCardQueryParams<
  GCC = GiftCardCategory,
  GCS = GiftCardSort,
  GCT = GiftCardType,
> {
  category?: GCC | null;
  searchByBrand?: string | null;
  sort?: GCS | null;
  type?: GCT | null;
}

export interface GiftCardFilterParams {
  type: string;
  category: string;
}

export interface GiftCardTypeOption<GCT = GiftCardType> {
  name: string;
  value: GCT;
}

export interface GiftCardCategoryOption<GCC = GiftCardCategory> {
  name: string;
  value: GCC;
}

export interface GiftCardSortOption<GCS = GiftCardSort> {
  name: string;
  value: GCS;
}
export interface GiftCard {
  id: string;
  name: string;
  categories: GiftCardCategory[];
  displayTypes: GiftCardType[];
  logoUrl?: URL;
  denominations: GiftCardDenomination[];
  imageUrls: string[];
  maxDiscountPercentage: number;
  shortDescription: string;
  // Only those in SHOW endpoint
  deliveryMethod?: GiftCardDeliveryMethod;
  description?: string;
  redemptionChannel?: GiftCardRedemptionChannel;
  redemptionInstructions?: string[];
  termsAndConditions?: string | null;
  termsAndConditionsUrl?: URL | null;
  validityInDays?: number;
}
